var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetamask = function SvgMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 0.5,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m3.784 2.708 8.41 6.39-1.368-3.681zM2.667 17.334l1.625 4.875 4.909-1.625-2.347-3.286z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m8.794 11.037-1.286 2.505 4.943.135-.474-5.552zM9.201 20.584l2.725-1.084-2.454-2.166z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m9.201 20.583 2.607 1.558.118-2.641z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m9.2 20.584.27-3.25H6.83z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m12.248 13.542-.42 2.629.56 2.889.126-3.808z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "M2.701 5.959 4.326 13l4.512-1.514 3.072-2.82-8.125-5.958z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m11.91 15.844-4.334-2.302 1.262-2.056L4.326 13l-1.659 4.333h6.805l2.454 2.167.462-.44z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "m9.472 15.437 2.438.813.338-2.709H7.576z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m11.91 16.25-2.438-.812 1.692-.813z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m16.224 5.417-1.37 3.68 8.412-6.389zM20.196 17.298l-2.329 3.286 4.89 1.625 1.626-4.875z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    d: "m15.024 8.26-.244 5.464 4.762-.183-1.133-2.166zM17.578 17.333 15.142 19.5l2.725 1.083z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7CCC8",
    d: "m15.142 19.5.1 2.64 2.625-1.557z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M20.219 17.333h-2.64l.288 3.25z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCAAA4",
    d: "M15.344 21.909v-.784h-3.638v.784l-2.505-1.325 2.708 2.166h3.232l2.727-2.166z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    d: "m23.266 2.708-8.107 5.959 3.053 2.819L22.743 13l1.607-7.042z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m22.743 13-4.53-1.514 1.261 2.055-4.274 2.48-.397-2.48-.266 1.711.126 3.808v-.004.004l.48.44 2.436-2.167h6.805z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FB8C00",
    d: "m10.826 5.417 1.083 3.25.361 5.057.11 1.536.008 3.8h1.137v-.024.024h1.138l.008-3.8.11-1.536.378-5.058 1.084-3.25z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m15.16 19.5-.51-.542H12.4l-.49.542-.204 1.625h3.638z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    d: "M19.474 13.542h-4.672l.338 2.708 2.438-.813z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "m15.904 14.625 1.675.813-2.437.812z"
  })));
};
export { SvgMetamask as ReactComponent };